import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-codalt-chip',
  templateUrl: './chip.component.html',
  styleUrl: './chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipComponent {
    text = input<string | number>();
    icon = input<string>();
    error = input<boolean>(false);
    dark = input<boolean>(false);
    light = input<boolean>(false);

    cssClass = input<string[]>();
}
